import React, { useEffect, useState, useCallback } from 'react';
import unsplash from '../api/unsplash';
import GlobalSnackbar from './Snackbar';
import LinearProgress from '@mui/material/LinearProgress';

import {
    Grid,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Zoom,
    DialogActions,
    DialogContentText,
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';

import { IconButton } from '@mui/material';

import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';

import { Add, Delete, Close, Check } from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const Reparti = ({ sede }) => {
    const [reparti, setReparti] = useState([]);
    const [loading, setLoading] = useState(true);
    const [repartoSelezionata, setRepartoSelezionata] = useState(null);
    const [openSnack, setOpenSnack] = useState(false);
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    const columns = [
        {
            filterable: false,
            field: 'Actions',
            headerName: 'Azioni',
            hide: false,
            width: '130',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <>
                    <IconButton
                        aria-label="edit"
                        onClick={async () => {
                            await setRepartoSelezionata(params.row);
                            document.getElementById('edit').click();
                            //handleClickOpen();
                        }}
                    >
                        <EditIcon
                            style={{
                                height: '2rem',
                                width: '2rem',
                                color: '#2265B1',
                            }}
                        />
                    </IconButton>

                    <DeleteDialog
                        reparto={params.row}
                        myFunction={handleDelete}
                    />
                </>
            ),
        },
        {
            field: 'Descrizione',
            headerName: 'Descrizione',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'Note',
            headerName: 'Note',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
    ];

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }

    const reloadAfterUpload = useCallback(async () => {
        try {
            let response = await unsplash.get('reparti', {
                params: {
                    reparti: sede.ID,
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });

            setReparti(response.data.data);
            setLoading(false);
        } catch (error) {
            console.error(error.message);
        }
    }, [sede.ID]);

    useEffect(() => {
        reloadAfterUpload();
    }, [reloadAfterUpload]);

    const handleSave = async (att, operazione) => {
        let rep = { ...att };
        if (operazione === 'new') {
            rep.IDSedi = sede.ID;
            try {
                await unsplash.post(
                    'reparti',
                    {
                        reparti: rep,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
                setSnack({
                    severity: 'success',
                    messaggio: 'Reparto creato con successo',
                });
                setOpenSnack(true);

                reloadAfterUpload();
            } catch {
                setSnack({
                    severity: 'error',
                    messaggio: 'Errore durante la creazione',
                });
                setOpenSnack(true);
            }
        } else {
            try {
                await unsplash.put(
                    'reparti',
                    {
                        reparti: rep,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
                setSnack({
                    severity: 'success',
                    messaggio: 'Reparto aggiornato con successo',
                });
                setOpenSnack(true);

                reloadAfterUpload();
            } catch {
                setSnack({
                    severity: 'error',
                    messaggio: "Errore durante l'aggiornamento",
                });
                setOpenSnack(true);
            }
            //handleClose();
        }
    };

    const handleDelete = async (att) => {
        try {
            await unsplash.delete('reparti', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                data: {
                    ID: att,
                },
            });

            setSnack({
                severity: 'success',
                messaggio: 'Reparto eliminato con successo',
            });
            setOpenSnack(true);
            reloadAfterUpload();
        } catch {
            setSnack({
                severity: 'error',
                messaggio: "Errore durante l'eliminazione dell'Reparto",
            });
            setOpenSnack(true);
        }
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={2}
            >
                <NewReparti
                    id="edit"
                    reparto={repartoSelezionata}
                    saveFunction={handleSave}
                    title="Modifica Reparto"
                />
                <NewReparti
                    id="new"
                    reparto={repartoSelezionata}
                    saveFunction={handleSave}
                    title="Nuovo Reparto"
                />
            </Grid>
            <Box sx={{ height: '60vh', width: 1 }}>
                <DataGridPro
                    initialState={{
                        pinnedColumns: { left: ['Actions'] },
                    }}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterPersonalized,
                    }}
                    slots={{
                        loadingOverlay: LinearProgress,
                    }}
                    loading={loading}
                    localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                    }
                    rowHeight={52}
                    rows={reparti}
                    columns={columns}
                    getRowId={(row) => row.ID}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                />
            </Box>
        </>
    );
};

export default Reparti;

const NewReparti = (props) => {
    const [open, setOpen] = useState(false);
    const [reparto, setReparto] = useState({
        Descrizione: '',
        Note: '',
        IDSedi: null,
    });

    const handleClickOpen = () => {
        if (props.id === 'edit') {
            setReparto(props.reparto);
        } else {
            setReparto({
                Descrizione: '',
                Note: '',
                IDSedi: null,
            });
        }
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (e) => {
        let copiaReparto = { ...reparto };
        copiaReparto[e.target.name] = e.target.value;
        setReparto(copiaReparto);
    };
    const handleSave = async () => {
        props.saveFunction(reparto, props.id);
        handleClose();
    };

    return (
        <>
            {props.id === 'edit' ? (
                <Button
                    startIcon={<Add />}
                    onClick={handleClickOpen}
                    id={props.id}
                    sx={{ color: 'white', display: 'none' }}
                    variant="outlined"
                    className="ButtonMiller"
                >
                    Aggiungi
                </Button>
            ) : (
                <Button
                    startIcon={<Add />}
                    onClick={handleClickOpen}
                    id={props.id}
                    sx={{ color: 'white' }}
                    variant="outlined"
                    className="ButtonMiller"
                >
                    Aggiungi
                </Button>
            )}

            <Grid
                container
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Dialog
                    open={open}
                    onClose={handleClose}
                    fullWidth={true}
                    maxWidth="md"
                    TransitionComponent={Transition}
                >
                    {/* Title Container */}
                    <DialogTitle
                        sx={{
                            mx: 'auto',
                        }}
                    >
                        {props.title}
                    </DialogTitle>
                    {/* Body Container */}
                    <DialogContent>
                        {/* Row 2 */}
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    value={reparto?.Descrizione}
                                    id="outlined-basic"
                                    label="Descrizione"
                                    name="Descrizione"
                                    onChange={handleChange}
                                    fullWidth
                                    sx={{ mt: 2 }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={reparto?.Note}
                                    id="outlined-basic"
                                    label="Note"
                                    name="Note"
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        {/* Bottoni Salva & Esci */}
                    </DialogContent>
                    <DialogActions
                        xs={12}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            mx: 2,
                        }}
                    >
                        <Button
                            onClick={handleClose}
                            variant="contained"
                            className="ButtonMiller"
                            startIcon={<Close />}
                        >
                            Chiudi
                        </Button>
                        <Button
                            onClick={handleSave}
                            variant="contained"
                            className="ButtonMiller"
                            startIcon={<Check />}
                        >
                            Salva
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </>
    );
};
const DeleteDialog = (props) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton aria-label="edit" onClick={handleClickOpen}>
                <Delete
                    style={{ height: '2rem', width: '2rem', color: '#FF2768' }}
                />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ mx: 'auto' }}>
                    Sei sicuro di voler eliminare il reparto selezionato?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Attenzione, sei sicuro di voler eliminare:
                        <b>{' ' + props.reparto.Descrizione}</b>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 3,
                    }}
                >
                    <Button onClick={handleClose}>annulla</Button>
                    <Button onClick={() => props.myFunction(props.reparto.ID)}>
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
